// @mui
import { LoadingButton } from '@mui/lab';
import { ButtonBase, Stack, Typography } from '@mui/material';

// components
import { Link } from 'react-router-dom';
import styles, { Icon } from "./styles.css";
import { openInNewTab } from '@src/utils/transform-helper';


export default function ForgotSentSuccess() {
  return (
    <>
     <Stack spacing={3} sx={styles.fss_stack} >
      <Stack  sx={{ my: 2, gap: "1.5rem" }}>
        <Icon
          alt="GWz check circle"
          src="/assets/icons/check-green-circle.svg"
          style={{ pointerEvents: 'none' }}
        />
        <Typography variant="h4" 
          sx={styles.t_email_sent}>EMAIL SENT!</Typography>
        <Typography variant="body1" 
          sx={styles.fss_t_description}>Please check your registered email and follow the instructions to update your password.</Typography>
      </Stack>

      <Link to="/login">
        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          sx={{
            background: "linear-gradient(90deg, #501794 0%, #3E70A1 100%)",
            color: "white",
            borderRadius: "10px",
            textTransform: "none",
            "&:hover": {
              background: "linear-gradient(90deg, #3E70A1 0%, #501794 100%)",
            },
          }}
        >
          Continue
        </LoadingButton>
      </Link>

      <Stack alignItems="center" justifyContent="center" sx={{ pt: 1 }}>
        <Typography display="inline" variant="body1" fontFamily={"Inter"} sx={{ fontSize: 14, fontWeight: "700", color: 'white' }}>
          Didn’t received an email?{" "}
          <ButtonBase onClick={() => openInNewTab("https://fortune8.online/contact-us")}>
            <Typography display="inline" 
              variant="body1" sx={{ fontSize: 14, fontWeight: "700", color: '#2563EB', fontFamily: "Inter" }}>
              Contact GWz Admin
            </Typography>
          </ButtonBase>
        </Typography>
      </Stack>
    </Stack>
    </>
  );
}
